interface Props {
    score?: number | null;
    tier?: string | null;
}

const tierColors: Record<string, string> = {
    "Angel Target": "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200",
    "High Priority": "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200",
    "Monitor": "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200",
    "Low Fit": "bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-300",
    "Disqualified": "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200",
};

export function ScoreBadge({ score, tier }: Props) {
    if (score == null || tier == null) {
        return <span className="text-xs text-muted-foreground">Not scored</span>;
    }
    const colorClass = tierColors[tier] ?? tierColors["Low Fit"];
    return (
        <span
            className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ${colorClass}`}
        >
            {score} — {tier}
        </span>
    );
}
